const ToolUseAction = {
  APPROVE: "APPROVE",
  ALWAYS_APPROVE: "ALWAYS_APPROVE",
  REJECT: "REJECT",
  AUTO_APPROVED: "AUTO_APPROVED",
};

export default ToolUseAction;
